// STYLES
import * as Style from "./LockerStatisticsStyle";

// LIBRARIES
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// MISC

// ASSETS

// REDUX

// COMPONENTS
import LockerStatisticElement from "components/LockerStatisticElement/LockerStatisticElement";

const LockerStatistics = ({ lockersStatisticsData }) => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const navigate = useNavigate();
  const { t } = useTranslation();

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleLockerDetails = (id) => {
    navigate(`/lockerDetails/${id}`);
  };

  return (
    <Style.LockerStatisticsContainer>
      <Style.ContainerTitle>
        {t("page.dashboard.lockerStatistics.title")}
      </Style.ContainerTitle>
      {lockersStatisticsData?.lockers?.map((lockerDetails, index) => (
        <LockerStatisticElement
          onClick={() => handleLockerDetails(lockerDetails.id)}
          key={index}
          lockerDetails={lockerDetails}
        />
      ))}
    </Style.LockerStatisticsContainer>
  );
};

export default LockerStatistics;
